import React from "react";
import { createUseStyles } from "react-jss";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { getColorOptions } from "./theming/colorOptions";
import { ColorOptions } from "./types";
import { classNames } from "./utils/classNames";
import parseChildren from "./utils/parseChildren";
import "react-tooltip/dist/react-tooltip.css";
var GLYPHICON_FEEDBACK_TYPE_MAP = {
    error: {
        glyphicon: "remove-sign",
        color: ColorOptions.Red,
    },
    warning: {
        glyphicon: "exclamation-sign",
        color: ColorOptions.Yellow,
    },
};
// TODO: Define base styles here too
var useTooltipIconClasses = function (color) {
    return createUseStyles({
        tooltipIcon: {
            color: getColorOptions({ color: color }),
        },
    })();
};
export var FeedbackTooltip = function (_a) {
    var tooltipId = _a.tooltipId, content = _a.content, children = _a.children, _b = _a.placement, placement = _b === void 0 ? "top" : _b, _c = _a.iconShown, iconShown = _c === void 0 ? true : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, type = _a.type, dataTestId = _a.dataTestId, dataLabel = _a.dataLabel, dataId = _a.dataId;
    var _e = GLYPHICON_FEEDBACK_TYPE_MAP[type], glyphicon = _e.glyphicon, color = _e.color;
    return (React.createElement(BasicTooltip, { tooltipId: tooltipId, content: content, children: children, placement: placement, iconShown: iconShown, disabled: disabled, dataTestId: dataTestId, dataLabel: dataLabel, dataId: dataId, glyphicon: glyphicon, color: color }));
};
export var Tooltip = function (_a) {
    var tooltipId = _a.tooltipId, content = _a.content, children = _a.children, _b = _a.placement, placement = _b === void 0 ? "top" : _b, _c = _a.iconShown, iconShown = _c === void 0 ? true : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, dataTestId = _a.dataTestId, dataLabel = _a.dataLabel, dataId = _a.dataId, _e = _a.glyphicon, glyphicon = _e === void 0 ? "question-sign" : _e;
    return (React.createElement(BasicTooltip, { tooltipId: tooltipId, content: content, children: children, placement: placement, iconShown: iconShown, disabled: disabled, dataTestId: dataTestId, dataLabel: dataLabel, dataId: dataId, glyphicon: glyphicon }));
};
var BasicTooltip = function (_a) {
    var _b, _c;
    var tooltipId = _a.tooltipId, content = _a.content, children = _a.children, _d = _a.placement, placement = _d === void 0 ? "top" : _d, _e = _a.iconShown, iconShown = _e === void 0 ? true : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, dataTestId = _a.dataTestId, dataLabel = _a.dataLabel, dataId = _a.dataId, _g = _a.glyphicon, glyphicon = _g === void 0 ? "question-sign" : _g, _h = _a.color, color = _h === void 0 ? ColorOptions.LightGrey : _h;
    var isString = false;
    var parsedChildren = parseChildren(children)[0];
    var isFormElement = ((_b = parsedChildren === null || parsedChildren === void 0 ? void 0 : parsedChildren.props) === null || _b === void 0 ? void 0 : _b.name) && ((_c = parsedChildren === null || parsedChildren === void 0 ? void 0 : parsedChildren.props) === null || _c === void 0 ? void 0 : _c.label);
    if ((typeof children === "string" || "number") &&
        typeof children !== "object") {
        isString = true;
    }
    var tooltipIconClasses = useTooltipIconClasses(color);
    if (iconShown && !isString) {
        return (React.createElement("div", { className: classNames("tooltip--wrapper", disabled ? "tooltip--disabled" : "", isFormElement ? "tooltip--formElement" : ""), "data-testid": dataTestId, "data-id": dataId, "data-label": dataLabel },
            children,
            React.createElement("span", { className: classNames("tooltip-icon", "glyphicon", "glyphicon-".concat(glyphicon), tooltipIconClasses.tooltipIcon), id: "".concat(tooltipId) }),
            React.createElement(RawTooltip, { anchorId: "".concat(tooltipId), placement: placement, content: content, disabled: disabled })));
    }
    return (React.createElement("div", { className: classNames("tooltip--wrapper", disabled ? "tooltip--disabled" : "", !!isFormElement ? "tooltip--formElement" : ""), "data-testid": dataTestId, "data-id": dataId, "data-label": dataLabel },
        isString ? (React.createElement("span", { id: "".concat(tooltipId), className: "tooltip--highlight-text" }, children)) : (React.createElement("div", { id: "".concat(tooltipId) }, children)),
        React.createElement(RawTooltip, { anchorId: "".concat(tooltipId), placement: placement, content: content, disabled: disabled })));
};
export var RawTooltip = function (_a) {
    var anchorId = _a.anchorId, content = _a.content, _b = _a.placement, placement = _b === void 0 ? "top" : _b, disabled = _a.disabled;
    if (disabled)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: "chromatic-ignore" },
        React.createElement(ReactTooltip, { place: placement, style: { backgroundColor: "#354551", fontSize: "100%" }, variant: "dark", id: "tooltip_".concat(anchorId), offset: 5, className: "tooltip--popup", anchorId: "".concat(anchorId) }, content)));
};
